module.exports = __webpack_public_path__ + "img/denmark-genitourinary-diseases-female.3ac5d285.png";